export default function getDivisors(n: number): number[] {
  if (n <= 0) {
    return []
  }

  const divisors: number[] = []

  for (let d: number = 1; d * d <= n; d++) {
    if (n % d !== 0) {
      continue
    }
    divisors.push(d)
    if (d !== n / d) {
      divisors.push(n / d)
    }
  }

  return divisors.sort((a: number, b: number): number => a - b)
}
